import { animate, style, transition, trigger } from "@angular/animations";
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { IdealBE } from "app/auth/models/deal-inferface";
import { AuthenticationService, UserService } from "app/auth/service";
import { ListService } from "app/auth/service/list.service";
import { UtilsService } from "app/auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import moment from "moment";
import { locale as italian } from "app/i18n/it";
import { IProductCommissionRound } from "app/modules/products/models/prodcuts-commissions";
import { ProductsCommissionsService } from "app/modules/products/products-commissions.service";
import { ProductDealsService } from "app/modules/products/products-deals.service";
import { ProductsService } from "app/modules/products/products.service";
import { ProductsOrdersService } from "app/modules/products/products-orders.service";
import { ICustomer } from "../../../../customer/customer.interface";
import { CustomerService } from "../../../../customer/customer.service";

@Component({
  selector: "app-product-commission-edit",
  templateUrl: "./product-commission-edit.component.html",
  styleUrls: ["./product-commission-edit.component.scss"],
  animations: [
    trigger("inOutAnimation", [
      transition(":enter", [style({ opacity: 0 }), animate("0.3s ease-out", style({ opacity: 1 }))]),
      transition(":leave", [style({ opacity: 1 }), animate("0.2s ease-in", style({ opacity: 0 }))]),
    ]),
  ],
})
export class ProductCommissionEditComponent implements OnInit {
  @ViewChild("detailOrder") detailOrder: ElementRef;
  @ViewChild("roundConflictDecision") roundConflictDecision: ElementRef;
  public contentHeader: IContentHeader;
  public formGroupDetail: FormGroup;
  public formGroupOrder: FormGroup;
  public currentCommission: any = {};
  public customersList: Array<ICustomer> = [];
  public productList: any = [];
  public paymentsTermsList: Array<any> = [];
  public billingFrequencyList: Array<any> = [];
  public dealsList: Array<IdealBE> = [];
  public dealsFilteredList: Array<IdealBE> = [];
  public activeTab: string = "orders";
  public orderList: Array<any> = [];
  public economicList: Array<any> = [];
  public selectedDeal: any = null;
  public typeDeal: string = null;
  public showErrors: boolean = false;
  public commissionID: number = null;
  public productsArray: Array<any> = [];
  public files_list: Array<any> = [];
  public files_list_obj: Array<any> = [];
  public attachments_list: Array<any> = [];
  public attachments_list_obj: Array<any> = [];
  public order_document: any = null;
  public order_document_name: string = null;
  public dealId: any = null;
  public closeMotivation: string = null;
  public editModeOrder: boolean = false;
  public todayDate: moment.Moment = moment();
  public selectedOrder: any = null;
  public actionAddRound: boolean = false;
  public actionAddRoundDealId: number = null;
  public actionEditOrderId: number = null;
  public total_estimated_cost: number = 0;
  public total_estimated_revenue: number = 0;
  public total_real_cost: number = 0;
  public total_real_profit: number = 0;
  public total_margin_euro: number = 0;
  public total_margin_percentage: string = "0";
  public invoiceTypeList: any[] = [];
  public paymentMeasureUnitList: any[] = [];
  public conflictRoundDetail: any = null;
  public openDetailProduct: boolean = false;
  public closeDate: string = moment().format("YYYY-MM-DD");
  public residualFromPrevOrders: number = 0;
  public closeRoundDate: any = null;

  constructor(
    public _utilService: UtilsService,
    public router: Router,
    public _authService: AuthenticationService,
    public _customerService: CustomerService,
    public _formBuilder: FormBuilder,
    public _modalService: NgbModal,
    public _changeDetectorRef: ChangeDetectorRef,
    public _userService: UserService,
    private _listService: ListService,
    private activatedRoute: ActivatedRoute,
    private _productsOrdersService: ProductsOrdersService,
    private _productsService: ProductsService,
    private _productsDealsService: ProductDealsService,
    private _productsCommissionsService: ProductsCommissionsService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.activatedRoute.params.subscribe((params) => {
      this.commissionID = Number(params.id);
    });
    this.activatedRoute.queryParams.subscribe((params) => {
      this.actionEditOrderId = Number(params.order_id);
      this.actionAddRound = params.add_order || params.add_deal_order;
      this.actionAddRoundDealId = Number(params.add_deal_order);

      if (params.tab_name) {
        this.activeTab = params.tab_name;
      }
    });

    this.contentHeader = {
      headerTitle: italian.data.MENU.EDIT_COMMISSION,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.COMMISSION",
            isLink: true,
            link: "/dashboard/commission/list",
          },
          {
            name: italian.data.MENU.EDIT_COMMISSION,
            isLink: false,
          },
        ],
      },
    };
    this.formGroupDetail = this._formBuilder.group({
      customer: new FormControl(null, [Validators.required]),
      name: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
    });
    this.formGroupOrder = this._formBuilder.group({
      deal_id: new FormControl(null, [Validators.required]),
      order_number: new FormControl(null),
      order_date: new FormControl(null),
      products_ids: new FormControl(null, [Validators.required]),
      from: new FormControl(null),
      to: new FormControl(null),
      capacity: new FormControl(null, [Validators.required]),
      invoice_type: new FormControl(null, [Validators.required]),
      payment_measure_unit: new FormControl(null, [Validators.required]),
      residue: new FormControl(null, [Validators.required]),
      description: new FormControl(null, [Validators.maxLength(1000)]),
      order_description: new FormControl(null, [Validators.maxLength(1000)]),
      payment_terms: new FormControl(null, [Validators.required]),
      billing_frequency: new FormControl(null, [Validators.required]),
      tranche_import: new FormControl(null),
      tranche_number: new FormControl(null),
      client_approval: new FormControl(false),
    });
  }

  //TODO: Implementare la colorazione come sulle commesse normali
  async ngOnInit() {
    if (!this._authService.hasCapability("edit_commission")) {
      this._utilService.hideLoading();
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    //List form back-end
    this.customersList = await this._customerService.getCustomers();
    this.customersList = this.customersList.sort((a, b) => (a.name > b.name ? 1 : -1));
    this.productList = await this._productsService.getProductsList();
    this.paymentsTermsList = await this._listService.getList("payment_terms");
    this.billingFrequencyList = await this._listService.getList("billing_frequency");
    this.paymentMeasureUnitList = await this._listService.getList("payment_measure_unit");
    this.invoiceTypeList = await this._listService.getList("invoice_document_type").then((invoiceType) => invoiceType.filter((item: any) => !item.other.credit_note))

    await this.loadCommission();
    //If true it's mean the user arrived in this page from order list and want to add a new order
    if (this.actionAddRound) {
      if (!this._authService.hasCapability("create_order")) {
        this._utilService.hideLoading();
        await this.router.navigateByUrl("/dashboard/main");
        return false;
      }
      await this.modalOpen(this.detailOrder, null);
    }
    //If it has an id it's mean the user arrived in this page from order list and want to edit an order
    if (this.actionEditOrderId) {
      if (!this._authService.hasCapability("edit_order")) {
        this._utilService.hideLoading();
        await this.router.navigateByUrl("/dashboard/main");
        return false;
      }
      const order = this.orderList.find((orderItem: any) => orderItem.order_id == this.actionEditOrderId);
      if (!order) {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "NOT_FOUND_ROUND" });
        return false;
      }
      await this.modalOpen(this.detailOrder, order);
    }
    this._utilService.hideLoading();
  }

  async loadCommission() {
    //Reset array (Useful when loadCommission is called not for the first time)
    this.orderList = [];
    this.economicList = [];
    this.total_estimated_cost = 0;
    this.total_estimated_revenue = 0;
    this.dealsList = await this._productsDealsService.getDeals();
    this.dealsList = this.dealsList.reverse();

    //If a deal has a commission is not available, so we take only deals without a commission ID and deals with the current commission ID
    this.dealsList = this.dealsList.filter((deal) => !deal.commission.id || deal.commission.id === this.commissionID);

    await this._productsCommissionsService
      .getCommission(this.commissionID)
      .then(async (response: any) => {
        this.currentCommission = response;
        if (!!this.currentCommission) {
          this.formGroupDetail.patchValue({
            customer: this.currentCommission.client.id,
            name: this.currentCommission.name,
          });
          if (this.currentCommission.orders && this.currentCommission.orders.length > 0) {
            const ordersForLoop: any = this.currentCommission.orders;

            //Sort for have order descending
            ordersForLoop.map((order: any) => {
              this.addOrderToArray(order);
            });
          }
          if (this.currentCommission.commission_analytics && this.currentCommission.commission_analytics.length > 0) {
            //Rimuovo le analytics che non hanno order_id
            this.currentCommission.commission_analytics = this.currentCommission.commission_analytics.filter((item: any) => !!item.order_id);
            this.currentCommission.commission_analytics.map((analytic: any, index: number) => {
              let totalEstimatedCost: number = 0;
              let totalEstimatedRevenue: number = 0;
              let totalRealCost: number = 0;
              let totalRealProfit: number = 0;
              this.economicList.push({
                internal_order: Number(analytic.order_id),
                order_number: analytic.order_id,
                month: !!analytic.month && !!analytic.year ? `${String(analytic.month).padStart(2, "0")} ${analytic?.year}` : null,
                estimated_cost: 0,
                effective_cost: 0,
                commissions_number: 0,
                estimated_revenue: 0,
                effective_revenue: 0,
                percentage_margin: 0,
                euro_margin: 0,
                products_details: [],
                open_modal: false,
                progressive_id: !!analytic?.progressive_id ? analytic.progressive_id : null,
              });
              if (analytic.employees_analytics && analytic.employees_analytics.length > 0) {
                analytic.employees_analytics.map((product) => {
                  this.economicList[index].products_details.push({
                    product_id: product.product_id,
                    product_name: product.name,
                    commissions_number: product.commissions_number,
                    estimated_cost: !!product.estimate_cost ? this._utilService.addDotsToNumber(product.estimate_cost) : 0,
                    estimated_revenue: !!product.estimate_profit ? this._utilService.addDotsToNumber(product.estimate_profit) : 0,
                    real_cost: !!product.real_cost ? this._utilService.addDotsToNumber(product.real_cost) : 0,
                    real_profit: !!product.real_profit ? this._utilService.addDotsToNumber(product.real_profit) : 0,
                  });
                  totalEstimatedCost += product.estimate_cost;
                  totalEstimatedRevenue += product.estimate_profit;
                  totalRealCost += product.real_cost;
                  totalRealProfit += product.real_profit;
                });
              }
              this.total_estimated_cost += totalEstimatedCost;
              this.total_estimated_revenue += totalEstimatedRevenue;
              this.total_real_cost += totalRealCost;
              this.total_real_profit += totalRealProfit;

              //Calcolo margine totale
              this.total_margin_euro = this.total_real_profit - this.total_real_cost;
              const multiplicationTotalMargin: number = this.total_margin_euro * 100;
              //Controllo che siano maggiori di zero. Se entrambi fossero di valore zero il risultato sarebbe NaN
              if (!!multiplicationTotalMargin && this.total_real_profit) {
                this.total_margin_percentage = (multiplicationTotalMargin / this.total_real_profit).toFixed(2);
              }
              this.economicList[index].estimated_revenue = this._utilService.addDotsToNumber(totalEstimatedRevenue);
              this.economicList[index].estimated_cost = this._utilService.addDotsToNumber(totalEstimatedCost);
              this.economicList[index].real_profit = this._utilService.addDotsToNumber(totalRealProfit);
              this.economicList[index].real_cost = this._utilService.addDotsToNumber(totalRealCost);
            });

            this.total_estimated_revenue = this._utilService.addDotsToNumber(this.total_estimated_revenue);
            this.total_estimated_cost = this._utilService.addDotsToNumber(this.total_estimated_cost);
            this.total_real_cost = this._utilService.addDotsToNumber(this.total_real_cost);
            this.total_real_profit = this._utilService.addDotsToNumber(this.total_real_profit);
            this.total_margin_euro = this._utilService.addDotsToNumber(this.total_margin_euro);
            //Sort for have order descending
            this.economicList = this.economicList.sort((a, b) => (a.internal_order < b.internal_order ? 1 : -1));

            if (this.orderList && this.orderList.length > 0) {
              this.orderList.map((order: any, index: number) => {
                order.progressive_id = `#${String(index + 1).padStart(2, "0")}`;
                order.classStyle = "white";
                if (this.economicList && this.economicList.length > 0) {
                  this.economicList.map((eco: any) => {
                    if (eco.order_number === order.order_id) {
                      eco.progressive_id = order.progressive_id;
                      eco.classStyle = "white";
                    }
                  });
                }
              });
            }
          }
        } else {
          //Show Error if we don't have found a commission
          await this._utilService.showSWALError({ text: "ERROR_NOT_FOUND_COMMISSION" });
          await this.router.navigateByUrl("/dashboard/commission/list");
          return false;
        }
      })
      .catch((err) => {
        if (err === "Unauthorized") {
          this.router.navigateByUrl("/dashboard/commission/list");
          this._utilService.showToastrError("NOT_AUTHORIZED");
          return false;
        }
      });
  }

  private addOrderToArray(order: any) {
    /*legend status order
     * NOT_STARTED 0 It will be possible to change everything
     * STARTED && ACTIVATED 1 It will be possible to change only end_date and name
     * EXPIRED 2 There is no edit if the order/order is expired*/
    let statusOrder: { status: number; color: string; label: string; closed_date: string } = {
      status: null,
      color: null,
      label: null,
      closed_date: null,
    };
    if (moment(order?.from) > this.todayDate && !order.closed) {
      statusOrder = {
        status: 0,
        color: "warning",
        label: italian.data.NOT_STARTED,
        closed_date: null,
      }; //NOT_STARTED
    }
    if (moment(order?.from) <= this.todayDate && moment(order?.to) > this.todayDate && !order.closed) {
      statusOrder = {
        status: 1,
        color: "success",
        label: italian.data.ACTIVATED_MASCULIN,
        closed_date: null,
      }; //STARTED && ACTIVATED
    }
    if (moment(order?.to) < this.todayDate && !order.closed) {
      statusOrder = {
        status: 2,
        color: "danger",
        label: italian.data.EXPIRED,
        closed_date: null,
      }; //EXPIRED
    }
    if (!!order.closed && !!order.closed_date) {
      statusOrder = {
        status: 3,
        color: "danger",
        label: italian.data.CLOSE_MASCULIN,
        closed_date: order.closed_date ? moment(order.closed_date).format("DD/MM/YYYY") : null,
      }; //CLOSED
    }
    this.orderList.push({
      id: order?.id,
      deal_id: order?.deal_id ? order.deal_id : null,
      deal_name: order?.deal_id ? order.deal_id : null,
      products_ids: order.products_ids,
      products_names: [],
      from: order?.from ? this._utilService.formatDate(order.from, "YYYY-MM-DD") : null,
      to: order?.to ? this._utilService.formatDate(order.to, "YYYY-MM-DD") : null,
      capacity: order?.capacity ? this._utilService.addDotsToNumber(order.capacity) : null,
      residue: order?.residue ? this._utilService.addDotsToNumber(order.residue) : null,
      order_number: order?.order_number ? order.order_number : null,
      order_date: order?.order_date ? this._utilService.formatDate(order.order_date, "YYYY-MM-DD") : null,
      description: order?.description ? order.description : null,
      order_description: order?.order_description ? order.order_description : null,
      payment_terms: order?.payment_terms_id ? order.payment_terms_id : null,
      tranche_import: order?.tranche_import ? this._utilService.addDotsToNumber(order.tranche_import) : null,
      tranche_number: order?.tranche_number ? order.tranche_number : null,
      billing_frequency: order?.billing_frequency_id ? order.billing_frequency_id : null,
      effort: order?.effort ? order.effort : null,
      invoice_type: order?.invoice_type ? order.invoice_type : null,
      payment_measure_unit: order?.payment_measure_unit ? order.payment_measure_unit : null,
      daily_rate: order?.deal_id ? this._utilService.addDotsToNumber(order.daily_rate) : null,
      file_url: order?.file_url ? order.file_url : null,
      file_name: order?.file_name ? order.file_name : null,
      order_attachments: order?.order_attachments ? order.order_attachments : null,
      status_order: statusOrder,
      closed: order.closed,
      status: order.status, //OPEN(0) OR CLOSED(1)
      order_id: order?.id ? order.id : null,
      detail: order?.detail ? order?.detail : [],
      client_approval: order.client_approval,
      progressive_id: order?.progressive_id ? order?.progressive_id : null,
    });
    if (order.products && order.products.length > 0) {
      order.products.map((product: any) => {
        const relativeOrder: any = this.orderList.find((o: any) => o.id === order.id);
        if (relativeOrder) {
          relativeOrder.products_names.push(product.name);
        }
      });
    }
  }

  ///////////////////////////////////////////////////////////////GENERAL FUNCTIONS////////////////////////////////

  getRowClass(row): string {
    if (row.classStyle === "grey") {
      return "bg-light-secondary text-dark";
    }
  }

  changeTab(tab: string) {
    this.activeTab = this.activeTab === tab ? "" : tab;
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroupOrder.controls[field_name].status === "INVALID";
    } else {
      return this.formGroupOrder.controls[field_name].status === "INVALID" && this.formGroupOrder.controls[field_name].touched;
    }
  }

  async modalOpen(modalBasic, currentOrder: any) {
    this._utilService.hideLoading();
    this.residualFromPrevOrders = 0;

    const modalName = modalBasic?._declarationTContainer?.localNames[0];
    if (modalName !== "closeCommissionModal" && modalName !== "roundConflictDecision") this.selectedOrder = null;
    this.filterDeals();
    if (!!currentOrder) {
      this.editModeOrder = true;
      this.selectedOrder = currentOrder;
      this.formGroupOrder.patchValue({
        deal_id: currentOrder.deal_id,
        order_number: currentOrder.order_number,
        order_date: currentOrder.order_date,
        products_ids: currentOrder.products_ids,
        from: currentOrder.from ? this._utilService.formatDate(currentOrder.from, "YYYY-MM-DD") : null,
        to: currentOrder.to ? this._utilService.formatDate(currentOrder.to, "YYYY-MM-DD") : null,
        capacity: currentOrder.capacity,
        residue: currentOrder.residue,
        payment_measure_unit: currentOrder.payment_measure_unit,
        invoice_type: currentOrder.invoice_type,
        description: currentOrder.description,
        order_description: currentOrder.order_description,
        payment_terms: currentOrder.payment_terms,
        billing_frequency: currentOrder.billing_frequency,
        effort: currentOrder.effort,
        daily_rate: currentOrder.daily_rate,
        tranche_import: currentOrder.tranche_import,
        tranche_number: currentOrder.tranche_number,
        client_approval: currentOrder.client_approval,
        order_id: currentOrder.id,
      });
      this.productsArray = currentOrder.detail;
      if (!!currentOrder.file_url) {
        this.order_document = currentOrder.file_url;
        this.order_document_name = currentOrder.file_name;
      }
      this.typeDeal = "Product";
      await this.selectDeal(true);
    } else {
      //Se sono presenti ordini andiamo a calcolare il residuo degli oridini presenti cosi da mostrarli nel crea ordine
      if (this.orderList && this.orderList.length > 0) {
        this.residualFromPrevOrders = this.orderList.reduce((acc, obj) => Number(acc) + this._utilService.removeDotsFromNumber(obj.residue), 0);
      }
      this.openDetailProduct = true;
      if (modalName !== "closeCommissionModal" && modalName !== "roundConflictDecision") {
        //check if there is an available deal without commission
        this.dealsFilteredList = this.dealsFilteredList.filter((deal) => !deal.commission.id);
        if (this.dealsFilteredList && this.dealsFilteredList.length < 1) {
          await this._utilService.showSWALError({ text: "NO_DEALS_FOR_SELECTED_CUSTOMER" });
          return false;
        } else {
          //If there is only one deal we push it directly to the selectedDeal
          if (this.dealsFilteredList && this.dealsFilteredList.length === 1) {
            this.dealId = this.dealsFilteredList[0].id;
            this.formGroupOrder.patchValue({
              deal_id: this.dealId,
            });
            await this.selectDeal();
          }
        }
        this.editModeOrder = false;
      }
    }
    if (!!this.actionAddRoundDealId) {
      //It means the user come from deals_list and want to add a new round and have already the deal id
      this.dealId = this.actionAddRoundDealId;
      this.formGroupOrder.patchValue({
        deal_id: this.actionAddRoundDealId,
      });
      await this.selectDeal();
    }
    this._modalService.open(modalBasic, {
      size: !!modalName && (modalName === "closeCommissionModal" || modalName === "roundConflictDecision") ? "sm" : "xl",
      centered: true,
      keyboard: false,
      backdrop: false,
    });
  }

  openModalCloseRound(modalBasic, currentOrder: any) {
    this.selectedOrder = currentOrder;
    if (this.selectedOrder) {
      if (!this.selectedOrder.closed) {
        this._modalService.open(modalBasic, {
          size: "sm",
          centered: true,
          keyboard: false,
          backdrop: false,
        });
      } else {
        this.manageStatusOrder();
      }
    }
  }

  modalClose() {
    this._modalService.dismissAll();
    this.formGroupOrder.reset();
    this.selectedOrder = null;
    this.conflictRoundDetail = null;
    this.typeDeal = null;
    this.selectedDeal = null;
    this.actionAddRoundDealId = null;
    this.actionEditOrderId = null;
    this.actionAddRound = false;
    this.dealId = null;
    this.closeMotivation = null;
    this.productsArray = [];
    this.files_list = [];
    this.files_list_obj = [];
    this.attachments_list = [];
    this.attachments_list_obj = [];
    this.order_document = null;
    this.closeRoundDate = null;
  }

  takeDate(event: any, field: string) {
    if (field === "from") {
      this.formGroupOrder.patchValue({
        from: event,
      });
    }
    if (field === "to") {
      this.formGroupOrder.patchValue({
        to: event,
      });
    }
    if (field === "order_date") {
      this.formGroupOrder.patchValue({
        order_date: event,
      });
    }
    if (field === "close_date") {
      this.closeDate = event;
    }
    if (field === "closeRoundDate") {
      this.closeRoundDate = event;
    }
  }

  resetCapacityAndResidue() {
    this.formGroupOrder.patchValue({
      capacity: null,
      residue: null,
    });
  }

  calculateSingleTrancheOnInit(discount: string, line_amount: string): string {
    if (this.formGroupOrder.value.tranche_number) {
      if (!discount) {
        if (!!line_amount) {
          return this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(line_amount) / this.formGroupOrder.value.tranche_number);
        } else {
          return "0,00";
        }
      } else {
        if (!!discount) {
          return this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(discount) / this.formGroupOrder.value.tranche_number);
        } else {
          return "0,00";
        }
      }
    } else {
      return "0,00";
    }
  }

  calculateCapacityOnInit() {
    this.resetCapacityAndResidue();
    //If is present tranche_import and tranche_number we're going to calculate capacity and residue
    if (this.productsArray && this.productsArray.length > 0) {
      this.productsArray.forEach((row) => {
        row.tranche_single_import = this.calculateSingleTrancheOnInit(row.discount, row.line_amount);
        if (!!this.formGroupOrder.value.tranche_number && this.formGroupOrder.value.tranche_number > 0 && !!row.tranche_single_import) {
          let capacity: number = this.formGroupOrder.value.tranche_number * this._utilService.removeDotsFromNumber(row.tranche_single_import);
          const discount: number = row.discount ? this._utilService.removeDotsFromNumber(row.discount) : 0;
          if (discount && discount !== 0) {
            //If there is a discount we're going to calculate discount divide by effort
            //Check if we have to round the value, if is it zero we don't need to round it
            let toDoMathRound: number = discount % (discount / this.formGroupOrder.value.tranche_number);
            row.tranche_single_import = this._utilService.addDotsToNumber(toDoMathRound !== 0 ? Math.round(discount / this.formGroupOrder.value.tranche_number) : discount / this.formGroupOrder.value.tranche_number);
            capacity = this.formGroupOrder.value.tranche_number * this._utilService.removeDotsFromNumber(row.tranche_single_import);
            this.formGroupOrder.patchValue({
              capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
              residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
            });
          } else {
            this.formGroupOrder.patchValue({
              capacity: !!this.formGroupOrder.value.capacity ? (this.formGroupOrder.value.capacity += capacity) : capacity,
              residue: !!this.formGroupOrder.value.residue ? (this.formGroupOrder.value.residue += capacity) : capacity,
            });
          }
        }
      });
    }
    //Adding dots to capacity and residue
    if (!!this.formGroupOrder.value.capacity && !!this.formGroupOrder.value.residue) {
      this.formGroupOrder.patchValue({
        capacity: this._utilService.addDotsToNumber(this.formGroupOrder.value.capacity),
        residue: this._utilService.addDotsToNumber(this.formGroupOrder.value.residue),
      });
    }
  }

  calculateCapacityAndTrancheImportSingleAndGeneral(): void {
    if (this.productsArray && this.productsArray.length > 0) {
      let sumAllTrancheImport: number = 0;
      this.productsArray.map((product: any) => {
        if (!!product.price && this.formGroupOrder.value.tranche_number && product.quantity) {
          product.tranche_single_import = this._utilService.addDotsToNumber((product.quantity * this._utilService.removeDotsFromNumber(product.price)) / this.formGroupOrder.value.tranche_number);
        }
        if (!!product.tranche_single_import) {
          sumAllTrancheImport += this._utilService.removeDotsFromNumber(product.tranche_single_import);
        }
      });
      this.formGroupOrder.patchValue({
        tranche_import: this._utilService.addDotsToNumber(sumAllTrancheImport),
        capacity: this._utilService.addDotsToNumber(sumAllTrancheImport * this.formGroupOrder.value.tranche_number),
        residue: this._utilService.addDotsToNumber(sumAllTrancheImport * this.formGroupOrder.value.tranche_number),
      });
    }
  }

  manageRow() {
    //Checking that a product has been deleted
    if (this.productsArray && this.productsArray.length > 0) {
      this.productsArray.map((item: any, index: number) => {
        if (item.product_id && !this.formGroupOrder.value.products_ids.includes(item.product_id)) {
          //If a user it's been removed we show an alert
          if (this.productsArray.length < 2) {
            this.productsArray.pop();
          } else {
            this.productsArray.splice(index, 1);
            this.productsArray = this.productsArray.filter((i) => i);
          }
        }
      });
    }

    //Checking that a product has been added
    if (this.formGroupOrder.value.products_ids && this.formGroupOrder.value.products_ids.length > 0) {
      this.formGroupOrder.value.products_ids.map((product_id: string, index: number) => {
        const alreadyInDatatable = this.productsArray.find((row) => row.product_id === product_id);
        if (!alreadyInDatatable) {
          this.productsArray.push({
            product_id: product_id ? product_id : null,
            product_name: this.productList.find((product) => product.id === Number(product_id)).name,
            tranche_single_import: null,
            quantity: null,
            price: null,
          });
          if (this.selectedDeal && this.selectedDeal.deal_document && this.selectedDeal.deal_document.table) {
            const product = this.selectedDeal.deal_document.table.find((row) => row.product_id === product_id);
            if (!!product && !!product.price) {
              this.productsArray[index].price = product.discount ? this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(product.discount) / product.quantity) : product.price;
              this.productsArray[index].tranche_single_import = null; //Calcolo nella funzione calculate Capacity
              this.productsArray[index].discount = product.discount;
              this.productsArray[index].quantity = product.quantity;
              this.productsArray[index].line_amount = product.line_amount;
            }
          }
        }
      });
    }
    this.calculateCapacityOnInit();
  }

  async calculateTrancheNumberAndFrequency() {
    this.showErrors = false;
    const startDate: moment.Moment = moment(this.formGroupOrder.value.from).clone();
    const endDate: moment.Moment = moment(this.formGroupOrder.value.to).clone();
    if (this.formGroupOrder.value.from && this.formGroupOrder.value.to) {
      if (startDate > endDate) {
        this.showErrors = true;
        await this._utilService.showSWALError({ text: "ERROR_DATE" });
        return false;
      }
      this.formGroupOrder.patchValue({
        tranche_number: endDate.diff(startDate, "months") === 0 ? 1 : Math.round(endDate.diff(startDate, "months", true)),
      });
      if (!!this.formGroupOrder.value.billing_frequency) {
        const billing: any = this.billingFrequencyList.find((i: any) => i.id === this.formGroupOrder.value.billing_frequency);
        let tranche: any = this.formGroupOrder.value.tranche_number;
        if (!!tranche) {
          const differenceTranche: number = Math.round(tranche / billing.other.month_value);
          this.formGroupOrder.patchValue({
            tranche_number: differenceTranche < 1 ? 1 : differenceTranche,
          });
          if (this.formGroupOrder.value.tranche_number === 0) {
            this.formGroupOrder.patchValue({
              tranche_number: 1,
            });
          }
        }
      }
    }
    this.calculateCapacityAndTrancheImportSingleAndGeneral();
  }

  ///////////////////////////////////////////////////////////////FORMAT MONEY FUNCTIONS////////////////////////////////

  formatMoneyValue(field: any) {
    this.formGroupOrder.patchValue({ [field]: this._utilService.addDotsToNumber(this.formGroupOrder.value[field]) });
    if (field === "capacity") {
      this.formGroupOrder.patchValue({
        //Residue it will always be filled as a capacity value
        residue: this.formGroupOrder.value.capacity,
      });
    }
  }

  formatPrice(index: number) {
    this.productsArray[index].price = this._utilService.addDotsToNumber(this.productsArray[index].price);
    this.calculateCapacityAndTrancheImportSingleAndGeneral();
  }

  //Function for filtering deals of the customer selected in detail commission
  async selectDeal(edit: boolean = false) {
    if (!edit) {
      this.productsArray = [];
      //Save the selected deal in a variable
      await this._productsDealsService
        .getDeal(this.formGroupOrder.value.deal_id)
        .then((response: any) => {
          this._utilService.showLoading();
          this.selectedDeal = response;
          //Also the type we're going to save
          this.typeDeal = this.selectedDeal.deal_type;
          //Here if we have soma values from the deal we're going to put in our formOrder
          this.formGroupOrder.patchValue({
            billing_frequency: this.selectedDeal?.billing_frequency ? this.selectedDeal.billing_frequency : null,
            from: this.selectedDeal?.start_date ? this._utilService.formatDate(this.selectedDeal.start_date, "YYYY-MM-DD") : null,
            to: this.selectedDeal?.end_date ? this._utilService.formatDate(this.selectedDeal.end_date, "YYYY-MM-DD") : null,
          });

          //Here the same for the products
          if (this.selectedDeal.products && this.selectedDeal.products.length > 0) {
            let productsIds: any = [];
            this.selectedDeal.products.map((pro: any) => {
              if (!!pro.id) {
                productsIds.push(pro.id);
              }
            });
            this.formGroupOrder.patchValue({
              products_ids: productsIds,
            });
          }
          this._utilService.hideLoading();
          //We call changTypeDeal for resetting some values and calculate effort and add users if they are present in the selected deal
          this.changeTypeDeal();
        })
        .catch(() => {
          this._utilService.hideLoading();
          this._utilService.showSWALError({ text: "ERROR_GET_DEAL" });
        });
    } else {
      this.selectedDeal = this.dealsList.find((d) => d.id === this.formGroupOrder.value.deal_id);
    }
  }

  //Function for filtering deals of the customer selected in detail commission
  filterDeals() {
    if (!!this.formGroupDetail.value.customer) {
      this.dealsFilteredList = this.dealsList.filter((d: any) => d.client.id === this.formGroupDetail.value.customer);
    }
  }

  changeTypeDeal() {
    //Reset values before calculating
    this.productsArray = [];
    this.formGroupOrder.patchValue({
      tranche_number: null,
      tranche_import: null,
      payment_measure_unit: null,
    });
    this.manageRow();
    //Here we suggest capacity only for the first time or when deal_type change
    const defaultPayment = this.paymentMeasureUnitList.find((el) => el.name.toLowerCase().includes("numero"));
    if (!!defaultPayment) {
      this.formGroupOrder.patchValue({
        payment_measure_unit: defaultPayment.id,
      });
    }
    if (!!this.selectedDeal.tranche_number) {
      const discountDeal: number = this._utilService.removeDotsFromNumber(this.selectedDeal?.deal_document?.table[0]?.total_discounted_deal);
      const totalDeal: number = this._utilService.removeDotsFromNumber(this.selectedDeal?.deal_document?.table[0]?.total_deal);
      let importTranche: any;
      if (discountDeal < totalDeal && discountDeal !== 0) {
        //If there is a discount we're going to calculate discount divide by tranche_number
        //Check if we have to round the value, if is it zero we don't need to round it
        let toDoMathRound: number = discountDeal % (discountDeal / this.selectedDeal.tranche_number);
        importTranche = this._utilService.addDotsToNumber(toDoMathRound !== 0 ? Math.round(discountDeal / this.selectedDeal.tranche_number) : discountDeal / this.selectedDeal.tranche_number);
      } else {
        importTranche = this._utilService.addDotsToNumber(totalDeal / this.selectedDeal.tranche_number);
      }
      this.formGroupOrder.patchValue({
        tranche_number: this.selectedDeal.tranche_number,
        tranche_import: importTranche,
      });
      this.calculateCapacityOnInit();
    }
  }

  openEconomicDetail(index: number) {
    this.economicList[index].open_modal = !this.economicList[index].open_modal;
  }

  //////////////////////////////////////////////////////////////// FILES FUNCTIONS////////////////////////////////
  async addFileToList(files: any) {
    //Reset variable, it will contain just one file, so if addFileToList is called we're gonna to overwrite the file list
    let updatedList: any[] = [];
    //For all files charged
    for (let file of files) {
      // controllo le dimensioni
      if (file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      //I add the file to the list that will be uploaded later
      this.files_list.push(file);
      //I add the file to the update list
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(file.size),
        status: 0,
      });
    }
    // I updated the variable for the page
    this.files_list_obj = updatedList;
  }

  resetFilesList() {
    this.files_list_obj = [];
    this.files_list = [];
  }

  removeFileFromList(index: any) {
    this.files_list_obj = this.files_list_obj.filter((item: any, i: number) => i !== index);
    this.files_list = this.files_list.filter((item: any, i: number) => i !== index);
  }

  //Attachments functions
  async addAttachmentToList(files: any) {
    // I create a variable from the actual list
    let updatedList: any[] = this.attachments_list_obj.filter((item: any) => item.name !== "");
    //For all files charged in the queue
    for (let file of files) {
      //check dimensions
      if (file.size > 10000000) {
        await this._utilService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      //If exits in the list I'll remove it
      const exists: any = updatedList.find((item: any) => item.name === file.name);
      // If exists remove it
      if (exists) {
        updatedList = updatedList.find((item: any) => item.name === file.name);
      }
      //If it does not exist I'll add it
      else {
        this.attachments_list.push(file);
      }
      //Add to updated list
      updatedList.push({
        name: file.name,
        size: this._utilService.formatBytes(file.size),
        status: 0,
      });
    }
    //I update the variable for the page
    this.attachments_list_obj = updatedList;
  }

  resetAttachmentsList() {
    this.attachments_list_obj = [];
    this.attachments_list = [];
  }

  removeAttachmentFromList(index: any) {
    this.attachments_list_obj = this.attachments_list_obj.filter((item: any, i: number) => i !== index);
    this.attachments_list = this.attachments_list.filter((item: any, i: number) => i !== index);
  }

  async uploadFiles(order_id: number) {
    // I'll wait for all files to be uploaded
    await Promise.all(
      this.files_list.map((file: File) => {
        return this._productsOrdersService.uploadDocument(file, order_id);
      }),
    ).catch(async () => {
      await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE" });
    });
  }

  async uploadAttachments(order_id: number) {
    // I'll wait for all attachments to be uploaded
    await Promise.all(
      this.attachments_list.map((file: File) => {
        return this._productsOrdersService.uploadAttachment(file, order_id);
      }),
    ).catch(async () => {
      await this._utilService.showSWALError({ text: "ERROR_UPLOAD_FILE" });
    });
  }

  async deleteAttachment(id: number) {
    await this._utilService
      .showSWAL({
        title: "CONFIRM_DELETE_FILE",
        icon: "error",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this._productsOrdersService
            .deleteAttachment(id)
            .then(async () => {
              this.selectedOrder.order_attachments = this.selectedOrder.order_attachments.filter((item) => item.id !== id);
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_FILE" });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DELETE_FILE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
  }

  async deleteDocument() {
    await this._utilService
      .showSWAL({
        title: "CONFIRM_DELETE_FILE",
        icon: "error",
        confirmButtonText: "CONFIRM_DELETE_BTN",
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
      .then(async (result) => {
        if (result.value) {
          await this._productsOrdersService
            .deleteDocument(this.selectedOrder.id)
            .then(async () => {
              this.selectedOrder.file_url = null;
              this.order_document = null;
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_FILE" });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DELETE_FILE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
  }

  async manageStatusOrder() {
    let data: { closed_date: string } = {
      closed_date: null,
    };
    if (this.selectedOrder && !this.selectedOrder.closed) {
      if (!this.closeRoundDate) {
        this.showErrors = true;
        return false;
      }
      data.closed_date = moment(this.closeRoundDate).format("YYYY-MM-DD");
    }
    this._utilService.showLoading();
    this._productsOrdersService
      .manageStatusOrder(this.selectedOrder.id, data)
      .then(async () => {
        this._utilService.hideLoading();
        if (this.selectedOrder && !this.selectedOrder.closed) {
          await this._utilService.showSWALSuccess({ text: "SUCCESS_CLOSE_ROUND" });
        } else {
          await this._utilService.showSWALSuccess({ text: "SUCCESS_REOPEN_ROUND" });
        }
        await this.loadCommission();
        this.modalClose();
      })
      .catch(async () => {
        this._utilService.hideLoading();
        if (this.selectedOrder && !this.selectedOrder.closed) {
          await this._utilService.showSWALError({ text: "ERROR_CLOSE_ROUND" });
        } else {
          await this._utilService.showSWALError({ text: "ERROR_REOPEN_ROUND" });
        }
      });
  }

  isClosingCommission(closedDate: any): boolean {
    return moment(closedDate) > this.todayDate;
  }

  async changeEndDateRoundBefore() {
    let data: any = {
      deal_id: this.conflictRoundDetail.conflictRound.deal_id,
      products_ids: this.conflictRoundDetail.conflictRound.products_ids,
      from: this.conflictRoundDetail.conflictRound.from ? this.conflictRoundDetail.conflictRound.from : null,
      to: this.conflictRoundDetail.newEndDate ? moment(this.conflictRoundDetail.newEndDate).add(23, "hours").add(59, "minutes").add(59, "seconds").format("YYYY-MM-DD HH:mm:ss") : null,
      capacity: this.conflictRoundDetail.conflictRound.capacity,
      invoice_type: this.conflictRoundDetail.conflictRound.invoice_type,
      payment_measure_unit: this.conflictRoundDetail.conflictRound.payment_measure_unit,
      residue: this.conflictRoundDetail.conflictRound.residue,
      order_number: this.conflictRoundDetail.conflictRound.order_number,
      order_date: !!this.conflictRoundDetail.conflictRound.order_date ? this.conflictRoundDetail.conflictRound.order_date : null,
      description: this.conflictRoundDetail.conflictRound.description,
      order_description: this.conflictRoundDetail.conflictRound.order_description,
      payment_terms: this.conflictRoundDetail.conflictRound.payment_terms,
      billing_frequency: this.conflictRoundDetail.conflictRound.billing_frequency,
      detail: this.productsArray,
      tranche_import: this.conflictRoundDetail.conflictRound.tranche_import,
      tranche_number: this.conflictRoundDetail.conflictRound.tranche_number,
      client_approval: this.conflictRoundDetail.conflictRound.client_approval,
      commission_id: this.currentCommission.id,
    };
    this._utilService.showLoading();
    await this._productsOrdersService
      .editOrder(this.conflictRoundDetail.roundBeforeId, data)
      .then(async () => {
        await this.loadCommission();
        if (this.editModeOrder) {
          await this.editOrder();
        } else {
          await this.createOrder();
        }
        this._utilService.hideLoading();
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_ROUND_DATE" });
      });
  }

  async createOrder() {
    if (!this._authService.hasCapability("create_order")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.showErrors = false;
    let productRowError: boolean = false;
    if (this.formGroupOrder.invalid) {
      await this._utilService.showSWALError({ text: "ERROR_EMPTY_FIELDS" });
      this.showErrors = true;
      return false;
    }
    if (!!this.formGroupOrder.value.from && !!this.formGroupOrder.value.to) {
      //Check date
      if (moment(this.formGroupOrder.value.from) > moment(this.formGroupOrder.value.to)) {
        this._utilService.hideLoading();
        this.showErrors = true;
        await this._utilService.showSWALError({ text: "ERROR_DATE" });
        return false;
      }
    } else {
      //Se uno dei due è fillato restituisco errore, devono essere necessariamente fillati entrambi
      if (!!this.formGroupOrder.value.from || !!this.formGroupOrder.value.to) {
        await this._utilService.showSWALError({ text: "ERROR_FILL_ALL_DATES" });
        this.showErrors = true;
        return false;
      }
    }

    //Check if they are trying to insert an order older than the current orders
    if (this.orderList && this.orderList.length > 0) {
      let errorsNum: number = 0;
      let originalEndDate: string = null;
      let roundBeforeId: string = null;
      let conflictRound: Object = null;
      let roundIsBiggerThanFromBefore: boolean = false;

      this.orderList.map((el: any) => {
        if (moment(this.formGroupOrder.value.from) > moment(el.from) && moment(this.formGroupOrder.value.from) <= moment(el.to)) {
          roundBeforeId = el.order_id;
          originalEndDate = el.to;
          errorsNum += 1;
          conflictRound = el;
        }
        if (moment(this.formGroupOrder.value.from) <= moment(el.from) && moment(this.formGroupOrder.value.from) <= moment(el.to)) {
          roundIsBiggerThanFromBefore = true;
        }
      });
      if (roundIsBiggerThanFromBefore) {
        await this._utilService.showSWALError({ text: "ERROR_DATE_ROUND_CONFLICT" });
        return false;
      }
      if (errorsNum > 0) {
        //Faccio decidere all'utente se vuole impostare il round in conflitto come data di scadenza il giorno prima alla data di partenza del nuovo round
        await this.modalOpen(this.roundConflictDecision, null);
        this.conflictRoundDetail = {
          originalEndDate: originalEndDate,
          newEndDate: moment(this.formGroupOrder.value.from).subtract(1, "days").format("YYYY-MM-DD"),
          roundBeforeId: roundBeforeId,
          conflictRound: conflictRound,
        };
        return false;
      }
    }
    //Check tranche_number and tranche_import
    if (!this.formGroupOrder.value.tranche_import || !this.formGroupOrder.value.tranche_number) {
      await this._utilService.showSWALError({ text: "ERROR_TRANCHE_TASK" });
      return false;
    }
    if (this.productsArray && this.productsArray.length > 0) {
      this.productsArray.map((pro) => {
        if (!pro.tranche_single_import || pro.tranche_single_import == 0) {
          productRowError = true;
        }
      });
    }
    if (productRowError) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_TASK_SINGLE_TRANCHE_IMPORT" });
      return false;
    }
    //Controllo se è stato caricato un file come ordine debbano essere riempiti i campi numero ordine e data ordine
    if (this.files_list && this.files_list.length > 0) {
      if (!this.formGroupOrder.value.order_number || !this.formGroupOrder.value.order_date) {
        await this._utilService.showSWALError({ text: "ERROR_ORDER_DATE_NUMBER_REQUIRED" });
        return false;
      }
    }
    this._utilService.showLoading();
    let data: IProductCommissionRound = {
      deal_id: this.formGroupOrder.value.deal_id,
      products_ids: this.formGroupOrder.value.products_ids,
      from: this.formGroupOrder.value.from ? this.formGroupOrder.value.from : moment().format("YYYY-MM-DD"),
      to: this.formGroupOrder.value.to ? moment(this.formGroupOrder.value.to).add(23, "hours").add(59, "minutes").add(59, "seconds").format("YYYY-MM-DD HH:mm:ss") : moment().format("YYYY-MM-DD"),
      capacity: this.formGroupOrder.value.capacity,
      invoice_type: this.formGroupOrder.value.invoice_type,
      payment_measure_unit: this.formGroupOrder.value.payment_measure_unit,
      residue: this.formGroupOrder.value.residue,
      order_number: this.formGroupOrder.value.order_number,
      order_date: !!this.formGroupOrder.value.order_date ? this.formGroupOrder.value.order_date : null,
      description: this.formGroupOrder.value.description,
      order_description: this.formGroupOrder.value.order_description,
      payment_terms: this.formGroupOrder.value.payment_terms,
      detail: this.productsArray,
      billing_frequency: this.formGroupOrder.value.billing_frequency,
      tranche_import: this.formGroupOrder.value.tranche_import,
      tranche_number: this.formGroupOrder.value.tranche_number,
      client_approval: this.formGroupOrder.value.client_approval,
      commission_id: this.currentCommission.id,
    };
    await this._productsOrdersService
      .addOrder(data)
      .then(async (res: any) => {
        //If there are files or attachments we're gonna the upload with the order_id
        if (res && res.order_id) {
          if (this.files_list && this.files_list.length > 0) {
            this._utilService.hideLoading();
            await this.uploadFiles(res.order_id);
          }
          if (this.attachments_list && this.attachments_list.length > 0) {
            this._utilService.hideLoading();
            await this.uploadAttachments(res.order_id);
          }
        }
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CREATE_ROUND" });
        this.modalClose();
        await this.loadCommission();
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_CREATE_ROUND" });
      });
  }

  async editOrder() {
    if (!this._authService.hasCapability("edit_order")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this.showErrors = false;
    let productRowError: boolean = false;

    if (this.formGroupOrder.invalid) {
      await this._utilService.showSWALError({ text: "ERROR_EMPTY_FIELDS" });
      this.showErrors = true;
      return false;
    }
    if (!!this.formGroupOrder.value.from && !!this.formGroupOrder.value.to) {
      //Check date
      if (moment(this.formGroupOrder.value.from) > moment(this.formGroupOrder.value.to)) {
        this._utilService.hideLoading();
        this.showErrors = true;
        await this._utilService.showSWALError({ text: "ERROR_DATE" });
        return false;
      }
    } else {
      //Se uno dei due è fillato restituisco errore, devono essere necessariamente fillati entrambi
      if (!!this.formGroupOrder.value.from || !!this.formGroupOrder.value.to) {
        await this._utilService.showSWALError({ text: "ERROR_FILL_ALL_DATES" });
        this.showErrors = true;
        return false;
      }
    }
    //Check tranche_number and tranche_import
    if (!this.formGroupOrder.value.tranche_import || !this.formGroupOrder.value.tranche_number) {
      await this._utilService.showSWALError({ text: "ERROR_TRANCHE_TASK" });
      return false;
    }
    if (this.productsArray && this.productsArray.length > 0) {
      this.productsArray.map((pro) => {
        if (!pro.tranche_single_import || pro.tranche_single_import == 0) {
          productRowError = true;
        }
      });
    }
    if (productRowError) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_TASK_SINGLE_TRANCHE_IMPORT" });
      return false;
    }
    //Controllo se è stato caricato un file come ordine debbano essere riempiti i campi numero ordine e data ordine
    if ((this.files_list && this.files_list.length > 0) || !!this.order_document) {
      if (!this.formGroupOrder.value.order_number || !this.formGroupOrder.value.order_date) {
        await this._utilService.showSWALError({ text: "ERROR_ORDER_DATE_NUMBER_REQUIRED" });
        return false;
      }
    }

    //Controllo se la capienza è stata cambiata aggiorniamo il residuo
    let updatedResidueAmount = null;
    let isAnIncrement: boolean = false;
    //Controllo che la capacità sia stata aggiornata e che il residuo sia diverso da capacità, nel caso siano uguali significa che non è stata fatta alcuna operazione quindi il residuo rimane uguale alla capacità
    if (this.formGroupOrder.value.capacity !== this.selectedOrder.capacity && this.selectedOrder.residue !== this.selectedOrder.capacity) {
      //Se la capienza nuova è maggiore della capienza salvata a db è un incremento e aggiungiamo la differenza tra le due al residuo cosi da poterlo aggiornare
      if (this._utilService.removeDotsFromNumber(this.formGroupOrder.value.capacity) > this._utilService.removeDotsFromNumber(this.selectedOrder.capacity)) {
        isAnIncrement = true;
        updatedResidueAmount = this._utilService.removeDotsFromNumber(this.formGroupOrder.value.capacity) - this._utilService.removeDotsFromNumber(this.selectedOrder.capacity);
      } else {
        //sottraiamo la differenza tra le due al residuo cosi da poterlo aggiornare
        updatedResidueAmount = this._utilService.removeDotsFromNumber(this.selectedOrder.capacity) - this._utilService.removeDotsFromNumber(this.formGroupOrder.value.capacity);
      }
    }
    this._utilService.showLoading();
    let data: IProductCommissionRound = {
      deal_id: this.formGroupOrder.value.deal_id,
      products_ids: this.formGroupOrder.value.products_ids,
      from: this.formGroupOrder.value.from ? this.formGroupOrder.value.from : moment().format("YYYY-MM-DD"),
      to: this.formGroupOrder.value.to ? moment(this.formGroupOrder.value.to).add(23, "hours").add(59, "minutes").add(59, "seconds").format("YYYY-MM-DD HH:mm:ss") : moment().format("YYYY-MM-DD"),
      capacity: this.formGroupOrder.value.capacity,
      residue: !!updatedResidueAmount
        ? isAnIncrement
          ? this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(this.selectedOrder.residue) + updatedResidueAmount)
          : this._utilService.addDotsToNumber(this._utilService.removeDotsFromNumber(this.selectedOrder.residue) - updatedResidueAmount)
        : this.formGroupOrder.value.residue,
      invoice_type: this.formGroupOrder.value.invoice_type,
      payment_measure_unit: this.formGroupOrder.value.payment_measure_unit,
      order_number: this.formGroupOrder.value.order_number,
      order_date: !!this.formGroupOrder.value.order_date ? this.formGroupOrder.value.order_date : null,
      description: this.formGroupOrder.value.description,
      order_description: this.formGroupOrder.value.order_description,
      payment_terms: this.formGroupOrder.value.payment_terms,
      billing_frequency: this.formGroupOrder.value.billing_frequency,
      detail: this.productsArray,
      tranche_import: this.formGroupOrder.value.tranche_import,
      tranche_number: this.formGroupOrder.value.tranche_number,
      client_approval: this.formGroupOrder.value.client_approval,
      commission_id: this.currentCommission.id,
    };
    //If there are files or attachments we're gonna the upload with the order_id
    if (this.selectedOrder.order_id) {
      if (this.files_list && this.files_list.length > 0) {
        await this.uploadFiles(this.selectedOrder.order_id);
      }
      if (this.attachments_list && this.attachments_list.length > 0) {
        await this.uploadAttachments(this.selectedOrder.order_id);
      }
    }
    await this._productsOrdersService
      .editOrder(this.selectedOrder.order_id, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_ROUND" });
        this.modalClose();
        await this.loadCommission();
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_ROUND" });
      });
  }

  async deleteOrder(order_id: number) {
    if (!this._authService.hasCapability("delete_order")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    await this._utilService
      .showSWALDeleteConfirmation({ text: "ALERT.CONFIRM_DELETE_TEXT" })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this._productsOrdersService
            .deleteOrder(order_id)
            .then(async () => {
              this.orderList = this.orderList.filter((item) => item.order_id != order_id);
              this._utilService.hideLoading();
              await this.loadCommission();
              await this._utilService.showSWALSuccess({ text: "SUCCESS_DELETE_ROUND" });
              //If there are no order we open automatically the modal for insert another order
              if (!this.orderList || this.orderList.length < 1) {
                await this.modalOpen(this.detailOrder, null);
              }
            })
            .catch(async (err: any) => {
              if (err == "This order has one or more reports.") {
                await this._utilService.showSWALError({ text: "ERROR_DELETE_ROUND_TO_MANY_REPORTS" });
              } else {
                await this._utilService.showSWALError({ text: "ERROR_DELETE_ROUND" });
              }
              this._utilService.hideLoading();
            });
        } else if (result.isDismissed) {
          this._utilService.hideLoading();
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_DELETE_ROUND" });
      });
  }

  async editCommission() {
    if (!this._authService.hasCapability("edit_commission")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    let data: any = {
      client_id: this.formGroupDetail.value.customer,
      name: this.formGroupDetail.value.name,
    };
    if (!!data.name) {
      data.name = data.name.trim();
    }
    if (!data.name || data.name.length < 1) {
      this._utilService.hideLoading();
      await this._utilService.showSWALError({ text: "ERROR_NAME_REQUIRED" });
      return false;
    }
    await this._productsCommissionsService
      .editCommission(this.commissionID, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_COMMISSION" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_COMMISSION" });
      });
  }

  async closeCommission() {
    if (!this._authService.hasCapability("edit_commission")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    if (!this.closeDate) {
      await this._utilService.showSWALError({ text: "INSERT_DATE" });
      return false;
    }
    this._utilService.showLoading();
    const data: any = {
      status: 1,
      status_note: this.closeMotivation,
      closed_date: this.closeDate,
    };
    this._productsCommissionsService
      .editStatusCommission(this.commissionID, data)
      .then(async () => {
        this.modalClose();
        this._utilService.hideLoading();
        await this.loadCommission();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_CLOSE_COMMISSION" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_CLOSE_COMMISSION" });
      });
  }

  async reOpenCommission() {
    if (!this._authService.hasCapability("edit_commission")) {
      await this.router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.showLoading();
    const data: any = {
      status: 0,
      status_note: "",
      closed_date: null,
    };
    this._productsCommissionsService
      .editStatusCommission(this.commissionID, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this.loadCommission();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_REOPEN_COMMISSION" });
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_REOPEN_COMMISSION" });
      });
  }
}
